import { useTypedQuery } from 'apiTyped/helpers/useTypedQuery';

export interface NotationWxrOptions {
  type: 'is_primeur' | 'is_livrable';
  vintage?: string;
}

export const useNotationHeader = () => {
  const { isLoading, data, refetch } = useTypedQuery(
    'get',
    '/communication/notation/header'
  );

  return {
    isLoading,
    header: data || { ratings: [] },
    refetch
  };
};

export const useNotationRaw = () => {
  const { isLoading, data, refetch } = useTypedQuery(
    'get',
    '/communication/notation/raw'
  );

  return {
    isLoading,
    raw: (data as any)?.data || [],
    refetch
  };
};

export const useNotationHeaderCompare = () => {
  const { isLoading, data, refetch } = useTypedQuery(
    'get',
    '/communication/notation/compare/header'
  );

  return {
    isLoading,
    headerCompare: data || {
      client_wines: [],
      appelations: [],
      classements: []
    },
    refetch
  };
};

export const useNotationCompare = (
  options: { rank?: string[]; appellation?: string[] } = {}
) => {
  const { isLoading, data, refetch } = useTypedQuery(
    'get',
    '/communication/notation/compare/data',
    {
      params: {
        query: {
          classements: options.rank?.join(',') || undefined,
          appelations: options.appellation?.join(',') || undefined
        }
      }
    }
  );

  return {
    isLoading,
    compare: data || { all_notes: [], wxr_notes: [] },
    refetch
  };
};

export const useNotationWxr = (options: NotationWxrOptions) => {
  const { isLoading, data, refetch } = useTypedQuery(
    'get',
    '/communication/notation/wxr/data',
    {
      params: {
        query: {
          is_primeur: options.type === 'is_primeur' ? true : undefined,
          is_livrable: options.type === 'is_livrable' ? true : undefined,
          vintage: options.vintage ? Number(options.vintage) : undefined
        }
      }
    }
  );

  return {
    isLoading,
    wxr: data || {
      filters: { classements: [], appellations: [], vintages: [], colors: [] },
      data: []
    },
    refetch
  };
};
